import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.865 14.25h.928l6.944-6.945-.927-.927-6.945 6.945v.927Zm10.278-7.758-2.531-2.508.978-.978c.22-.22.488-.33.803-.33.316 0 .583.11.803.33l.913.913c.22.22.335.484.342.792a1.04 1.04 0 0 1-.319.791l-.989.99Zm-.813.825L5.27 15.375h-2.53v-2.531l8.057-8.058 2.532 2.53Zm-2.06-.479-.46-.46.927.927-.467-.467Z" }));
const ForwardRef = forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
